import { scaleLinear } from 'd3-scale';

function getValueFromXScale(index, xScale) {
  var _ref2;

  if (xScale instanceof scaleLinear) {
    var _ref;

    return (_ref = xScale(Number(index))) !== null && _ref !== void 0 ? _ref : 0;
  }

  return (_ref2 = xScale(`${index}`)) !== null && _ref2 !== void 0 ? _ref2 : 0;
}

export { getValueFromXScale };
